import React, { useState } from "react";
import { Link } from "react-router-dom";
import { organisation, trainings } from "../../data/clearith";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  training: trainings[0].title,
  situation: "",
  message: "",
  consent: false,
};

const ContactForm: React.FC = () => {
  const [values, setValues] = useState(initialValues);
  const [status, setStatus] = useState("");

  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const target = event.target;
    const value =
      target instanceof HTMLInputElement && target.type === "checkbox"
        ? target.checked
        : target.value;
    setValues((current) => ({ ...current, [target.name]: value }));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const subject = encodeURIComponent(
      "Demande d’information — " + values.training
    );
    const body = encodeURIComponent(
      [
        "Nom : " + values.lastName,
        "Prénom : " + values.firstName,
        "E-mail : " + values.email,
        "Téléphone : " + values.phone,
        "Formation : " + values.training,
        "Situation professionnelle : " + values.situation,
        "",
        "Message :",
        values.message,
      ].join("\n")
    );

    setStatus(
      "Votre logiciel de messagerie va s’ouvrir avec votre demande préremplie."
    );
    window.location.href =
      "mailto:" + organisation.email + "?subject=" + subject + "&body=" + body;
  };

  return (
    <form className="cl-form" onSubmit={handleSubmit}>
      <div className="row g-3">
        <div className="col-md-6">
          <label htmlFor="contact-first-name">Prénom *</label>
          <input
            id="contact-first-name"
            type="text"
            name="firstName"
            value={values.firstName}
            onChange={handleChange}
            autoComplete="given-name"
            required
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="contact-last-name">Nom *</label>
          <input
            id="contact-last-name"
            type="text"
            name="lastName"
            value={values.lastName}
            onChange={handleChange}
            autoComplete="family-name"
            required
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="contact-email">E-mail *</label>
          <input
            id="contact-email"
            type="email"
            name="email"
            value={values.email}
            onChange={handleChange}
            autoComplete="email"
            required
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="contact-phone">Téléphone *</label>
          <input
            id="contact-phone"
            type="tel"
            name="phone"
            value={values.phone}
            onChange={handleChange}
            autoComplete="tel"
            required
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="contact-training">Formation concernée *</label>
          <select
            id="contact-training"
            name="training"
            value={values.training}
            onChange={handleChange}
            required
          >
            {trainings.map((training) => (
              <option key={training.slug} value={training.title}>
                {training.title}
              </option>
            ))}
            <option value="Autre demande">Autre demande</option>
          </select>
        </div>
        <div className="col-md-6">
          <label htmlFor="contact-situation">Situation professionnelle *</label>
          <select
            id="contact-situation"
            name="situation"
            value={values.situation}
            onChange={handleChange}
            required
          >
            <option value="">Sélectionner</option>
            <option value="Salarié">Salarié</option>
            <option value="Demandeur d’emploi">Demandeur d’emploi</option>
            <option value="Indépendant">Indépendant</option>
            <option value="Entrepreneur">Entrepreneur</option>
            <option value="Manager ou dirigeant">Manager ou dirigeant</option>
            <option value="Autre">Autre</option>
          </select>
        </div>
        <div className="col-12">
          <label htmlFor="contact-message">Message *</label>
          <textarea
            id="contact-message"
            name="message"
            value={values.message}
            onChange={handleChange}
            rows={6}
            required
          />
        </div>
        <div className="col-12">
          <label className="cl-consent" htmlFor="contact-consent">
            <input
              id="contact-consent"
              type="checkbox"
              name="consent"
              checked={values.consent}
              onChange={handleChange}
              required
            />
            <span>
              J’accepte que mes informations soient utilisées pour répondre à
              ma demande, conformément à la{" "}
              <Link to="/politique-confidentialite">
                politique de confidentialité
              </Link>
              . *
            </span>
          </label>
        </div>
      </div>
      <div className="cl-form__footer">
        <button type="submit" className="thm-btn agency-btn">
          <span className="text">Envoyer la demande</span>
        </button>
        <p aria-live="polite">{status}</p>
      </div>
    </form>
  );
};

export default ContactForm;
